module.exports = __webpack_public_path__ + "static/media/03.c7605fb9.mp3";